import React, { useEffect, useState } from "react";

import {
  getAllClientBulkUploadReportAction,
  resetAllClientBulkUploadList,
  resetAllClientBulkUploadTotalCount,
  resetListingError,
  resetListingSuccess,
} from "../../../../redux/listing";
import useDebounce from "../../../../customHooks/useDebounce";
import { EmptyListPage, ErrorSuccessModal, TableLoader } from "../../../commons";
import { EmptyList } from "../../../../assets/images";
import { RootState } from "../../../../redux/rootReducers";
import {
  getAllFinacUsersAction,
  resetFinacUsersList,
  resetSession,
} from "../../../../redux/auth";
import { connect } from "react-redux";
import AllClientBulkUploadTable from "./AllClientBulkUploadTable";
import { GetAllFinacUserPayloadType } from "../../../../commonTypes/authTypes";
import AllClientBulkUploadFilter from "./AllClientBulkUploadFilter";
import { GetClientDirectoryListPayloadType } from "../../../../commonTypes/clientDirectoryTypes";
import { getClientDirectoryListAction } from "../../../../redux/clientDirectory";
import { ClientDirectoryListType } from "../../../../redux/clientDirectory/clientDirectoryType";
import {
  getTokenGenerateForDownloadAction,
  resetSasTokenForDownloadFile,
} from "../../../../redux/stcoTools";
import { GetGenerateSasTokenPayloadType } from "../../../../commonTypes/stcoToolsType";
import { GetAllClientBulkUploadHistoryPayloadType } from "../../../../commonTypes/listing";

export type FilterTextType = {
  userText: string;
  clientText: string;
};

export type FilterOffsetType = {
  userOffset: number;
  clientOffset: number;
};
export type DropDownItemType = {
  value: number | null | undefined;
  label: string;
};

export type FilterMultiSelectDataType = {
  client: { label: string; value: number | null };
  user: { label: string; value: number | null };
  type: { label: string; value: string | null };
  status: string|number;
};
type AppProps = {
  history: any;
  activeTab: any;
  fetching: boolean;
  success: null | number;
  error: null | string;
  statusCode: null | number;
  token: null | string;
  allClientBulkUploadTotalCount: number;
  allClientBulkUploadList: any[] | [];
  dispatchResetSession: () => void;
  dispatchResetListingError: () => void;
  dispatchResetListingSuccess: () => void;
  dispatchResetAllClientBulkUploadList: () => void;
  dispatchGetAllClientBulkUploadReportAction: (data: GetAllClientBulkUploadHistoryPayloadType) => void;
  dispatchResetAllClientBulkUploadTotalCount: () => void;
  userFetching: boolean;
  finacUsersList: any;
  dispatchResetFinacUsersList: () => void;
  dispatchGetAllFinacUsersAction: (data: GetAllFinacUserPayloadType) => void;
  clientDirectoryFetching: boolean;
  dispatchGetClientDirectoryListAction: (
    data: GetClientDirectoryListPayloadType
  ) => void;
  totalClientCount: any;
  clientDirectoryList: [] | ClientDirectoryListType[];
  dispatchGetTokenGenerateForDownloadAction: (
    data: GetGenerateSasTokenPayloadType
  ) => void;
  dispatchResetSasTokenForDownloadFile: () => void;
  sasTokenForDownloadFile: string;
};
const AllClientBulkUpload = ({
  history,
  activeTab,
  fetching,
  success,
  error,
  statusCode,
  token,
  allClientBulkUploadTotalCount,
  allClientBulkUploadList,
  dispatchResetSession,
  dispatchResetListingError,
  dispatchResetListingSuccess,
  dispatchResetAllClientBulkUploadList,
  dispatchGetAllClientBulkUploadReportAction,
  dispatchResetAllClientBulkUploadTotalCount,
  userFetching,
  finacUsersList,
  dispatchResetFinacUsersList,
  dispatchGetAllFinacUsersAction,
  clientDirectoryFetching,
  dispatchGetClientDirectoryListAction,
  totalClientCount,
  clientDirectoryList,
  dispatchGetTokenGenerateForDownloadAction,
  dispatchResetSasTokenForDownloadFile,
  sasTokenForDownloadFile,
}: AppProps) => {
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(20);
  const [data, setData] = useState<any[]>([]);
  const [finalUserList, setFinalUserList] = useState<DropDownItemType[] | []>(
    []
  );
  const [filterToggle, setFilterToggle] = useState<boolean>(false);
  const [filterOffset, setFilterOffset] = useState<FilterOffsetType>({
    userOffset: 0,
    clientOffset: 0,
  });
  const [filterText, setFilterText] = useState<FilterTextType>({
    userText: "",
    clientText: "",
  });
  const [multiSelectData, setMultiSelectData] =
    useState<FilterMultiSelectDataType>({
      client: { label: "", value: null },
      user: { label: "", value: null },
      type: { label: "", value: null },
      status: "",
    });
  const [filterValue, setFilterValue] = useState<FilterMultiSelectDataType>({
    client: { label: "", value: null },
    user: { label: "", value: null },
    type: { label: "", value: null },
    status: "",
  });
  const [finalClientList, setFinalClientList] = useState<DropDownItemType[] | []>(
    []
  );

  useEffect(() => {
    window.scroll({
      top: 0,
      left: 0,
    });
    dispatchResetAllClientBulkUploadList();
    dispatchResetListingError();
    dispatchResetListingSuccess();
    dispatchResetAllClientBulkUploadTotalCount();
    dispatchResetFinacUsersList();
  }, []);

  useEffect(() => {
    if (allClientBulkUploadList?.length === 0) {
      setData(allClientBulkUploadList);
    }
    if (offset > 0) {
      setData((prv: any) => [...prv, ...allClientBulkUploadList]);
    } else {
      setData(allClientBulkUploadList);
    }
  }, [allClientBulkUploadList]);

  useEffect(() => {
    dispatchResetListingSuccess();
    dispatchResetListingError();
    if (token) {
      let finalData: GetAllClientBulkUploadHistoryPayloadType = {
        token,
        limit,
        offset,
        userId: filterValue?.user?.value ? filterValue?.user?.value : null,
        clientCode: filterValue?.client?.value
          ? filterValue?.client?.value
          : null,
        type: filterValue?.type?.value ? filterValue?.type?.value : null,
        status: filterValue?.status,
      };

      if ( +allClientBulkUploadTotalCount > 0) {
        if (offset < allClientBulkUploadTotalCount) {

          dispatchGetAllClientBulkUploadReportAction(finalData);
        }
      } else {

        dispatchGetAllClientBulkUploadReportAction(finalData);
      }
    }
  }, [offset]);

  useEffect(() => {
    if (finacUsersList?.data?.length > 0) {
      if (filterOffset?.userOffset <= +finacUsersList?.total_count) {
        let finalUserData = finacUsersList?.data?.map((user: any) => {
          return {
            value: user.user_id,
            label: `${user.first_name} ${user.last_name}`,
            image: user?.profile_pic?.file_url,
          };
        });
        if (filterOffset?.userOffset > 0) {
          setFinalUserList([...finalUserList, ...finalUserData]);
        } else {
          setFinalUserList([...finalUserData]);
        }
      }
    }
  }, [finacUsersList?.data]);
  useEffect(() => {
    if (token) {
      let finalData = {
        token,
        search_term: filterText?.userText,
        user_type: "stco_users",
        limit,
        offset: filterOffset?.userOffset,
        status: "1",
      };

      if (+finacUsersList?.total_count) {
        if (+finacUsersList?.total_count > filterOffset?.userOffset) {
          dispatchGetAllFinacUsersAction(finalData);
        }
      } else {
        dispatchGetAllFinacUsersAction(finalData);
      }
    }
  }, [filterOffset?.userOffset]);
  useDebounce(
    () => {
      if (filterText?.userText) {
        fetchNewFilterData(filterText?.userText);
      } else {
        const finalData = {
          token,
          offset: filterOffset?.userOffset,
          limit,
          user_type: "stco_users",
          status: 1,
          search_term: "",
        };
        dispatchGetAllFinacUsersAction(finalData);
      }
    },
    500,
    [filterText?.userText]
  );
  const fetchNewFilterData = (search: string) => {
    const finalData = {
      token,
      offset: filterOffset?.userOffset,
      limit,
      user_type: "stco_users",
      status: 1,
      search_term: filterText?.userText,
    };
    dispatchGetAllFinacUsersAction(finalData);
  };

  useEffect(() => {
    if (clientDirectoryList?.length) {
      if (filterOffset?.clientOffset <= +totalClientCount) {
        let finalClientData = clientDirectoryList?.map((e: any) => {
          return {
            value: e?.client_code,
            label: `(${e?.client_code}) ${e?.company_name}`,
          };
        });
        if (filterOffset?.clientOffset > 0) {
          setFinalClientList([...finalClientList, ...finalClientData]);
        } else {
          setFinalClientList([...finalClientData]);
        }
      }
    }
  }, [clientDirectoryList]);

  useEffect(() => {
    if (token && totalClientCount) {
      if (filterOffset?.clientOffset <= +totalClientCount) {
        const finalData = {
          token,
          status: 1,
          offset: filterOffset?.clientOffset,
          limit,
          searchValue: filterText?.clientText,
        };
        dispatchGetClientDirectoryListAction(finalData);
      }
    }
  }, [filterOffset?.clientOffset]);

  const fetchNewClientData = () => {
    if (token) {
      const finalData = {
        token,
        offset: filterOffset?.clientOffset,
        limit,
        searchValue: filterText?.clientText,
        status: 1,
      };

      dispatchGetClientDirectoryListAction(finalData);
    }
  };

  useDebounce(
    () => {
      fetchNewClientData();
    },
    500,
    [filterText?.clientText]
  );

  const onScroll = () => {
    if (!fetching) {
      const scrollTop = document.documentElement.scrollTop;
      const scrollHeight = document.documentElement.scrollHeight;
      const clientHeight = document.documentElement.clientHeight;

      if (
        offset < allClientBulkUploadTotalCount &&
        !fetching &&
        Math.ceil((75 / 100) * scrollHeight) <= scrollTop + clientHeight
      ) {
        if (allClientBulkUploadList?.length > 0) {
          if (!fetching && offset < allClientBulkUploadTotalCount) {
            setOffset(offset + limit);
          }
        }
      }
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, [allClientBulkUploadList]);
  const handleApplyFilter = () => {
    dispatchResetAllClientBulkUploadList();
    setData([]);
    setOffset(0);
    setMultiSelectData({
      client: filterValue?.client,
      type: filterValue?.type,
      user: filterValue?.user,
      status: filterValue?.status,
    });

    if (token) {
      let finalData: GetAllClientBulkUploadHistoryPayloadType = {
        token,
        limit,
        offset:0,
        userId: filterValue?.user?.value ? filterValue?.user?.value : null,
        clientCode: filterValue?.client?.value
          ? filterValue?.client?.value
          : null,
        type: filterValue?.type?.value ? filterValue?.type?.value : null,
        status: filterValue?.status,
      };

        dispatchGetAllClientBulkUploadReportAction(finalData);
     
    }
  };

  const handleFilterClear = () => {
    dispatchResetAllClientBulkUploadList();
    setFilterValue({
      client: { label: "", value: null },
      user: { label: "", value: null },
      type: { label: "", value: null },
      status: "",
    });

    setMultiSelectData({
      client: { label: "", value: null },
      user: { label: "", value: null },
      type: { label: "", value: null },
      status: "",
    });

    if (token) {
      let finalData: GetAllClientBulkUploadHistoryPayloadType = {
        token,
        limit,
        offset,
      };

      dispatchGetAllClientBulkUploadReportAction(finalData);
    }
  };

    const handleErrorModal = () => {
      if (success === 0) {
        if (statusCode === 401) {
          return (
            <ErrorSuccessModal
              type="error"
              isOpen={!!error}
              title="Error"
              message="Session Expired. Please Login Again!"
              buttonText="Logout"
              onPress={() => dispatchResetSession()}
              statusCode={statusCode}
            />
          );
        } else if (!!error && statusCode !== 401) {
          return (
            <ErrorSuccessModal
              type="error"
              isOpen={!!error}
              title="Error"
              message={error}
              buttonText="OK"
              onPress={() => {
                dispatchResetListingError();
              }}
            />
          );
        }
      }
  
      return false;
    };

  return (
    <div className="">
      <div className="jobs-card">
        <div className="header">
          <div className="left-header">
            <div className="heading mb-0 mt-0">
              All Client Wise Bulk Upload History
            </div>
            <div className="sub-heading">{`Total ${
              allClientBulkUploadTotalCount ? allClientBulkUploadTotalCount : 0
            } list found`}</div>
          </div>

          <div className="right-header">
            <div className="mr-1">
              <AllClientBulkUploadFilter
                setToggle={setFilterToggle}
                toggle={filterToggle}
                filterValue={filterValue}
                setFilterValue={setFilterValue}
                multiSelectData={multiSelectData}
                limit={limit}
                handleApplyFilter={handleApplyFilter}
                handleFilterClear={handleFilterClear}
                finalUserList={finalUserList}
                setFilterText={setFilterText}
                setUserOffset={setOffset}
                finalClientList={finalClientList}
                setFilterOffset={setFilterOffset}
              />
            </div>
          </div>
        </div>

        <div>
          {fetching && offset == 0 ? (
            <TableLoader Rows={10} ColumnPerRow={7} />
          ) : allClientBulkUploadList?.length > 0 ? (
            <AllClientBulkUploadTable
              data={data}
              fetching={fetching}
              offset={offset}
              sasTokenForDownloadFile={sasTokenForDownloadFile}
              dispatchResetSasTokenForDownloadFile={
                dispatchResetSasTokenForDownloadFile
              }
              dispatchGetTokenGenerateForDownloadAction={
                dispatchGetTokenGenerateForDownloadAction
              }
              token={token}
            />
          ) : (
            <div className="mt-5 pb-5">
              {!fetching && allClientBulkUploadList?.length === 0 && (
                <EmptyListPage
                  title="No List Found!"
                  image={EmptyList}
                  imageWidth="30%"
                />
              )}
            </div>
          )}
        </div>
      </div>
      {handleErrorModal()}

    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  success: state.listing.success,
  fetching: state.listing.fetching,
  statusCode: state.listing.statusCode,
  error: state.listing.error,
  allClientBulkUploadList: state.listing.allClientBulkUploadList,
  allClientBulkUploadTotalCount: state.listing.allClientBulkUploadTotalCount,
  userFetching: state.auth.fetching,
  finacUsersList: state.auth.finacUsersList,
  clientDirectoryFetching: state.clientDirectory.fetching,
  totalClientCount: state.clientDirectory.totalCount,
  clientDirectoryList: state.clientDirectory.clientDirectoryList,
  sasTokenForDownloadFile: state.stcoTools.sasTokenForDownloadFile,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetListingError: () => dispatch(resetListingError()),
  dispatchResetListingSuccess: () => dispatch(resetListingSuccess()),
  dispatchResetAllClientBulkUploadList: () =>
    dispatch(resetAllClientBulkUploadList()),
  dispatchGetAllClientBulkUploadReportAction: (data: GetAllClientBulkUploadHistoryPayloadType) =>
    dispatch(getAllClientBulkUploadReportAction(data)),
  dispatchResetAllClientBulkUploadTotalCount: () =>
    dispatch(resetAllClientBulkUploadTotalCount()),
  dispatchResetFinacUsersList: () => dispatch(resetFinacUsersList()),
  dispatchGetAllFinacUsersAction: (data: GetAllFinacUserPayloadType) =>
    dispatch(getAllFinacUsersAction(data)),
  dispatchGetClientDirectoryListAction: (
    data: GetClientDirectoryListPayloadType
  ) => dispatch(getClientDirectoryListAction(data)),
  dispatchGetTokenGenerateForDownloadAction: (
    data: GetGenerateSasTokenPayloadType
  ) => dispatch(getTokenGenerateForDownloadAction(data)),
  dispatchResetSasTokenForDownloadFile: () =>
    dispatch(resetSasTokenForDownloadFile()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AllClientBulkUpload);
